module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"frames":"Kozijnen","doors":"Deuren","walls":"Muren","ceiling":"Plafonds","dormer":"Dakkapel","stairs":"Trap","unknown":"Weet ik niet"}}')
  delete Component.options._Ctor
}
